import styled from 'styled-components'
import { withOpacity } from '../../helpers'

export default styled.nav`
  position: relative;

  .menu-button {
    display: none;
    position: relative;
    width: 44px;
    height: 44px;
    padding: 0;
    border: 1px solid ${ ({ theme }) => withOpacity(theme.colors.white, 50) };
    border-radius: 50%;
    background-color: ${ ({ theme }) => withOpacity(theme.colors.white, 10) };
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${ ({ theme }) => theme.colors.landingHighlight };
      outline-offset: 2px;
    }
  }

  .menu-bars,
  .menu-bars::before,
  .menu-bars::after {
    position: absolute;
    left: 13px;
    width: 18px;
    height: 2px;
    border-radius: 1px;
    background-color: ${ ({ theme }) => theme.colors.white };
  }

  .menu-bars {
    top: 21px;

    &::before,
    &::after {
      content: '';
      left: 0;
    }

    &::before {
      top: -6px;
    }

    &::after {
      top: 6px;
    }
  }

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 32px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  a {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    color: ${ ({ theme }) => theme.colors.white };
    font-size: 14px;
    font-weight: bold;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid ${ ({ theme }) => theme.colors.landingHighlight };
      outline-offset: 2px;
    }
  }

  @media screen and (max-width: 768px) {
    .menu-button {
      display: block;
    }

    ul {
      position: absolute;
      top: calc(100% + 12px);
      right: 0;
      z-index: 20;
      flex-direction: column;
      gap: 0;
      min-width: 220px;
      padding: 12px 0;
      border-radius: 12px;
      background-color: ${ ({ theme }) => theme.colors.landingDark };
      box-shadow: 0 8px 24px ${ ({ theme }) => withOpacity(theme.colors.landingDark, 35) };
      visibility: hidden;
      opacity: 0;
      transform: translateY(-8px);
      transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out, visibility 0.2s;

      &.open {
        visibility: visible;
        opacity: 1;
        transform: translateY(0);
      }
    }

    a {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    ul {
      transition: none;
    }
  }
`
